module.exports = __webpack_public_path__ + "fonts/D-DIN-Italic.817b684e.ttf";